import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "react-bootstrap/Button";


import { Swiper, SwiperSlide } from 'swiper/react';
import Carousel from 'react-bootstrap/Carousel';
import 'swiper/css';
import 'swiper/css/pagination';
import GitchaMobileLogo from "../images/gitcha-mobile-logo.svg";
import CarouselImage1 from "../images/carousel-img-1.png";
import CarouselImage2 from "../images/carousel-img-2.png";
import CarouselImage3 from "../images/carousel-img-3.png";
import GoogleLogo from "../images/google-logo.svg";
import { Autoplay, Pagination } from 'swiper/modules';
const CreateAccount = () => {
  const pagination = {
    clickable: true,
    
  };


  return (
    <div className="mobile-wrapper bg-grey-variant">

      <div className="mobile-wrapper-inner bg-grey-variant">
        <div className="welcome-header">
        <img src={GitchaMobileLogo} alt={GitchaMobileLogo} />
          <h2>Welcome to Gitcha</h2>
          <p>Revolutionizing the real estate industry by focusing on your client's wants and needs. </p>
        </div>

        <div>
        <Swiper
        pagination={pagination}
        modules={[Pagination]}
        className="mySwiper"
        rewind={true}
        autoplay={{
          delay: 800,
          disableOnInteraction: false,
        }}
      >
        <SwiperSlide>
           <img src={CarouselImage1} alt={CarouselImage1} />
           <p className="swiper-carousel-para">Share exactly what your client is looking for in their next property, all in one place.</p>
           </SwiperSlide>
        <SwiperSlide>
          <img src={CarouselImage2} alt={CarouselImage2} />
          <p className="swiper-carousel-para">Find matches to what you have with what others are looking for and gauge demand of your property.</p>
          </SwiperSlide>
        <SwiperSlide>
          <img src={CarouselImage3} alt={CarouselImage3} />
          <p className="swiper-carousel-para">Save the back and forth by privately introducing your home to interested buyers and renters. </p>
          </SwiperSlide>
        
      </Swiper>
        </div>
        
        {/*<div className="welcome-slider">
                      
                     
                      
                      <Carousel interval={6000} wrap={true}>
                      <Carousel.Item>
                        
                        <img src={CarouselImage1} alt={CarouselImage1} />
                        
                        <Carousel.Caption>
                          
                          <p>Share exactly what your client is looking for in their next property, all in one place.</p>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                      <img src={CarouselImage2} alt={CarouselImage2} />
                        <Carousel.Caption>
                          
                          <p>Share exactly what your client is looking for in their next property, all in one place.</p>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                      <img src={CarouselImage3} alt={CarouselImage3} />
                        <Carousel.Caption>
                          
                          <p>
                          Share vvbdfg gdfg dgfdgvcxvcxvccyyyy jhjjk jhjhjkv hhh exactly what your client is looking for in their next property, all in one place.
                          </p>
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                      

                     


                  </div>*/}
                        <div className="btn-wrap pb-4">
                          <button type="button" class="btn btn-primary w-100 mb-3">Continue With Email</button>
                          <button type="button" class="btn btn-outline-primary w-100 mb-2"><img src={GoogleLogo} alt={GoogleLogo} className="me-2" /> <span className="text-placement">Continue with google</span></button>
                          <button type="button" class="btn btn-no-bg w-100">Skip and Start Browsing</button>
                  
                        </div>
        
      </div>
    </div>
  );
};

export default CreateAccount;
